"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var download_helper_1 = require("@services/download-helper");
var feature_flipper_1 = require("@shared/constants/feature-flipper");
var environment_1 = require("@shared/types/environment");
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var EE_EXPORT_FILE_TYPES = {
    PDF: download_helper_1.EXPORT_FILE_TYPES.PDF,
    PPTX: download_helper_1.EXPORT_FILE_TYPES.PPTX,
    EDITABLE_PPTX: 'EDITABLE_PPTX',
    STANDARD_PPTX: 'STANDARD_PPTX'
};
var EE_EXPORT_TYPE_TO_EXPORT_FILE_TYPE = (_a = {},
    _a[EE_EXPORT_FILE_TYPES.PDF] = download_helper_1.EXPORT_FILE_TYPES.PDF,
    _a[EE_EXPORT_FILE_TYPES.PPTX] = download_helper_1.EXPORT_FILE_TYPES.PPTX,
    _a[EE_EXPORT_FILE_TYPES.EDITABLE_PPTX] = download_helper_1.EXPORT_FILE_TYPES.PPTX,
    _a[EE_EXPORT_FILE_TYPES.STANDARD_PPTX] = download_helper_1.EXPORT_FILE_TYPES.PPTX,
    _a);
var ExportModalController = /** @class */ (function () {
    function ExportModalController($scope, downloadHelper, metricsService, env, $filter) {
        this.$scope = $scope;
        this.downloadHelper = downloadHelper;
        this.metricsService = metricsService;
        this.env = env;
        this.$filter = $filter;
        this.translate = this.$filter('translate');
        $scope.$ctrl = this;
        this.fileType = EE_EXPORT_FILE_TYPES.PDF;
    }
    ExportModalController.prototype.getOptions = function () {
        var _this = this;
        return lodash_1.default.map(this.getExportFileTypes(), function (value, key) {
            return {
                value: value,
                label: _this.translate(key),
                selected: _this.fileType === value
            };
        });
    };
    ExportModalController.prototype.setFileType = function (fileType) {
        this.fileType = fileType;
    };
    ExportModalController.prototype.download = function () {
        var fileType = EE_EXPORT_TYPE_TO_EXPORT_FILE_TYPE[this.fileType];
        var metricFileType = fileType;
        var reportDownloadOptions = {};
        if (this.fileType === EE_EXPORT_FILE_TYPES.EDITABLE_PPTX) {
            reportDownloadOptions.editableWidgets = true;
            metricFileType = EE_EXPORT_FILE_TYPES.EDITABLE_PPTX;
        }
        this.metricsService.exportComplete(metricFileType, this.metricsService.EXPORT_CALL_SOURCE.EE);
        return this.downloadHelper.exportReport(fileType, reportDownloadOptions);
    };
    ExportModalController.prototype.getExportFileTypes = function () {
        var _a;
        var supportedFileTypes = new Set();
        var isEditablePptxEnabled = !!((_a = (this.env.get(environment_1.ENV_VARS.FEATURES))) === null || _a === void 0 ? void 0 : _a[feature_flipper_1.FEATURES.EDITABLE_WIDGETS_PPTX]);
        if (isEditablePptxEnabled) {
            supportedFileTypes.add(EE_EXPORT_FILE_TYPES.PDF);
            supportedFileTypes.add(EE_EXPORT_FILE_TYPES.EDITABLE_PPTX);
            supportedFileTypes.add(EE_EXPORT_FILE_TYPES.STANDARD_PPTX);
        }
        else {
            supportedFileTypes.add(EE_EXPORT_FILE_TYPES.PDF);
            supportedFileTypes.add(EE_EXPORT_FILE_TYPES.PPTX);
        }
        return lodash_1.default.pickBy(EE_EXPORT_FILE_TYPES, function (value) { return supportedFileTypes.has(value); });
    };
    ExportModalController.$inject = [
        '$scope',
        'prDownloadHelper',
        'prMetricsService',
        'rsEnvironment',
        '$filter'
    ];
    return ExportModalController;
}());
(function (angularModule) {
    angularModule.controller('prEeExportModalController', ExportModalController);
})(angular.module('qualtrics.pr'));
